module.exports = __webpack_public_path__ + "static/media/editPen.1429b0a1.svg";